import React from 'react'
import styles from '../index.css'
import { Link } from 'react-router-dom'

function Home() {
  return (
    <div className={styles.homeContainer} >
      <h1>Github Battle: Battle your friends</h1>
      <Link className={styles.button} to='/battle' >Battle</Link> 
    </div>
  ) 
}

export default Home



// WEBPACK FOOTER //
// ./app/components/Home.js